import { get }      from '@/services/api/methods';
import { post }     from '@/services/api/methods';
import { put }      from '@/services/api/methods';
import { del }      from '@/services/api/methods';

export default {

	getDealLinks: ({ searchString, filters, page, per, sortBy, sortDir }) => {
		return get('/deal-links', {
			options: {
				searchString,
				filters,
				page,
				per,
				sortBy: 'created_date',
				sortDir: 'desc'
			}
		});
	},

	getDealLink: ({ linkId }) => {
		return get(`/deal-links/${linkId}`);
	},

	createDealLink: ({ link }) => {
		return post('/deal-links', {
			requestData: link
		});
	},

	deleteDealLink: ({ linkId }) => {
		return del(`/deal-links/${linkId}`);
	},

	updateDealLink: ({ linkId, link }) => {
		return put(`/deal-links/${linkId}`, {
			requestData: link
		});
	}
};
